import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      sx={{
        width: '100%',
        py: 1.7,
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #ddd',
        textAlign: 'center',
        position: 'fixed',  
        bottom: 0,          
        left: 0,
        zIndex: 1000,       
      }}
    >
      <Typography
        variant="body2"
        color="textSecondary"
        fontWeight={500}
      >
        © {new Date().getFullYear()} SVM Sweets. Powered by{' '}
        <Link
          href="https://genxthofa.com/"
          target="_blank"
          rel="noopener"
          underline="hover"
          color="error"
        >
          Genx Thofa Technologies
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
